import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root-redirect',
  standalone: true,
  imports: [],
  template: '',
  styleUrl: './root-redirect.component.scss'
})
export class RootRedirectComponent {
  constructor(private router: Router) { }

  ngOnInit(): void {
    const authType = JSON.parse(localStorage.getItem("authenticationType") || '0');
    this.router.navigate([authType === 6 ? '/Home' : '/Login']); // 6 = PingIdentity
  }
}
